import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError} from "../../../../../../../../logics/api_config";
import {useApiRentriCalls} from "../../../api-hooks/api_rentri_config";
import {
    IRentriProvenienza
} from "../../../../../../../../utils/interfaces/special_wasty/rentri/codifiche/rifiuto/IRentriProvenienza";


const useApiGetRentriProvenienza = (): UseQueryResult<IRentriProvenienza[], CustomAxiosError> => {
    const {get} = useApiRentriCalls()

    async function doGet(): Promise<IRentriProvenienza[]> {
        try {
            const response = await get(`/codifiche/v1.0/lookup/provenienza`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRentriProvenienza"],
        queryFn: () => doGet(),
    })
};

export default useApiGetRentriProvenienza